import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { statisticWinnerListHandler } from '../../../helpers/statisticWinnerList';
import { useIdsGenerator } from '../../../hooks/useIdsGenerator';
import { BET_TYPES_VIEW } from '../../../enums/betTypesEnum';
import { bigRoadStatisticCreateHandler } from '../../../helpers/bigRoad';
import { BACCARAT_STATISTICS_TYPES } from '../../../enums/constants';

const arr = new Array(98).fill(null);
const arrMobile = new Array(84).fill(null);
const resultRowCountMobile = 7;

function StatisticListWr({
  winBetTypes,
  statisticType,
  StatisticListComp,
  WinMarketsComp,
  ResultListComp,
  isMobile,
  isReplay,
}) {
  const statisticContainer = useRef();
  const resultsContainer = useRef();

  const statisticList = useMemo(() => {
    if (statisticType === BACCARAT_STATISTICS_TYPES.BIG_ROAD1) {
      return statisticWinnerListHandler(
        bigRoadStatisticCreateHandler(
          statisticWinnerListHandler(winBetTypes),
          BACCARAT_STATISTICS_TYPES.BIG_ROAD1
        )
      );
    }
    if (statisticType === BACCARAT_STATISTICS_TYPES.BIG_ROAD2) {
      return statisticWinnerListHandler(
        bigRoadStatisticCreateHandler(
          statisticWinnerListHandler(winBetTypes),
          BACCARAT_STATISTICS_TYPES.BIG_ROAD2
        )
      );
    }
    if (statisticType === BACCARAT_STATISTICS_TYPES.BIG_ROAD3) {
      return statisticWinnerListHandler(
        bigRoadStatisticCreateHandler(
          statisticWinnerListHandler(winBetTypes),
          BACCARAT_STATISTICS_TYPES.BIG_ROAD3
        )
      );
    }
    return statisticWinnerListHandler(winBetTypes) || [];
  }, [winBetTypes, statisticType]);

  const winMarketsCounts = useMemo(() => {
    return winBetTypes?.reduce(
      (acc, cur) => {
        if (cur?.roundData.winType === BET_TYPES_VIEW.TIE) {
          acc.tieCount += 1;
        } else if (cur?.roundData.winType === BET_TYPES_VIEW.PLAYER) {
          if (cur?.roundData.isPairWin) {
            acc.playerWinWithPairCount += 1;
          }
          acc.playerWinCount += 1;
        } else {
          if (cur?.roundData.isPairWin) {
            acc.bankerWinWithPairCount += 1;
          }
          acc.bankerWinCount += 1;
        }
        return acc;
      },
      {
        roundNumberAfterShuffle: winBetTypes.length,
        bankerWinCount: 0,
        bankerWinWithPairCount: 0,
        playerWinCount: 0,
        playerWinWithPairCount: 0,
        tieCount: 0,
      }
    );
  }, [winBetTypes]);

  const pseudoStatisticIds = useIdsGenerator(isMobile ? arrMobile : arr, [statisticList]);
  const statisticIds = useIdsGenerator(statisticList);

  const memoWinBetTypes = useMemo(() => {
    if (winBetTypes) {
      const result = winBetTypes.filter((data) => data.roundData);
      if (result.length % resultRowCountMobile) {
        const pseudoArray = new Array(
          resultRowCountMobile - (result.length % resultRowCountMobile)
        ).fill(null);
        return result.concat(pseudoArray);
      }
      return result;
    }
    return null;
  }, [winBetTypes]);
  const pseudoWinBetTypesIds = useIdsGenerator(arrMobile, [memoWinBetTypes]);
  const winBetTypesIds = useIdsGenerator(memoWinBetTypes);

  const scrollToMyRef = useCallback(() => {
    if (!statisticContainer.current) return;
    statisticContainer.current.scrollLeft =
      statisticContainer.current.scrollWidth - statisticContainer.current.clientWidth;
  }, [statisticContainer]);

  const resultsScrollToMyRef = useCallback(() => {
    if (!resultsContainer.current) return;
    resultsContainer.current.scrollLeft =
      resultsContainer.current.scrollWidth - resultsContainer.current.clientWidth;
  }, [resultsContainer]);

  useEffect(() => {
    scrollToMyRef();
    resultsScrollToMyRef();
  }, [scrollToMyRef, winBetTypes, resultsScrollToMyRef]);

  return (
    <>
      {/* statisticContainer, memoWinBetTypes, columnsCount, pseudoWinBetTypesIds, winBetTypesIds, */}
      {!isReplay && <WinMarketsComp statistics={winMarketsCounts || {}} />}
      {isMobile ? (
        <div className='betting-block-section'>
          <ResultListComp
            resultsContainer={resultsContainer}
            memoWinBetTypes={memoWinBetTypes}
            columnsCount={arrMobile}
            pseudoWinBetTypesIds={pseudoWinBetTypesIds}
            winBetTypesIds={winBetTypesIds}
          />
          <StatisticListComp
            arr={arrMobile}
            statisticContainer={statisticContainer}
            scrollToMyRef={scrollToMyRef}
            statisticIds={statisticIds}
            statisticList={statisticList}
            pseudoStatisticIds={pseudoStatisticIds}
          />
        </div>
      ) : (
        <StatisticListComp
          arr={arr}
          statisticContainer={statisticContainer}
          scrollToMyRef={scrollToMyRef}
          statisticIds={statisticIds}
          statisticList={statisticList}
          pseudoStatisticIds={pseudoStatisticIds}
        />
      )}
    </>
  );
}

export default StatisticListWr;
